import {useCallback} from 'react';
import {useMarketerSelectionStore} from '../store/MarketerSelectionStore';
import {SelectMarketerUseCase} from '../useCases/SelectMarketerUseCase';

export const useMarketerControl = () => {
  // الحصول على الـ use case
  const selectMarketer = new SelectMarketerUseCase();

  // الحصول على الحالة من الـ store
  const {marketers, selectedMarketer, setSelectedMarketer, setError} = useMarketerSelectionStore();

  // اختيار مسوق
  const handleSelectMarketer = useCallback((marketerId?: string) => {
    try {
      const result = selectMarketer.execute({
        marketerId: marketerId || '',
        marketers
      });

      if (result.success) {
        setSelectedMarketer(result.selectedMarketer);
      } else {
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Failed to select marketer');
    }
  }, [selectMarketer, marketers, setSelectedMarketer, setError]);

  // اختيار أقرب مسوق لموقع معين
  const handleSelectNearestMarketer = useCallback((latitude: number, longitude: number, maxDistance?: number) => {
    try {
      const result = selectMarketer.selectMarketerByLocation(marketers, latitude, longitude, maxDistance);

      if (result.success) {
        setSelectedMarketer(result.selectedMarketer);
      } else {
      }
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Failed to select nearest marketer');
    }
  }, [selectMarketer, marketers, setSelectedMarketer, setError]);

  // مسح الاختيار
  const handleClearSelection = useCallback(() => {
    handleSelectMarketer(undefined);
  }, [handleSelectMarketer]);

  return {
    // State
    marketers,
    selectedMarketer,

    // Actions
    selectMarketer: handleSelectMarketer,
    selectNearestMarketer: handleSelectNearestMarketer,
    clearSelection: handleClearSelection
  };
};
